import { useQuery } from '@tanstack/react-query'

import { isAccessDenied, isTransientQueryError } from './useAttributionObservability'

import type { AttributionDimension, AttributionFilters } from '@/api/attributionObservability'
import {
  getSummaryChipCohorts,
  getSummaryChipOverview,
  getSummaryChipTrend,
  type SummaryChipSource,
} from '@/api/summaryChipMetrics'

const defaults = {
  staleTime: 30_000,
  gcTime: 5 * 60_000,
  retry: (attempt: number, error: unknown) => attempt < 1 && !isAccessDenied(error) && isTransientQueryError(error),
} as const

export const useSummaryChipOverview = (filters: AttributionFilters, enabled: boolean, source: SummaryChipSource) =>
  useQuery({
    ...defaults,
    enabled,
    queryKey: ['attribution-observability', 'summary-chips', 'overview', filters, source],
    queryFn: ({ signal }) => getSummaryChipOverview(filters, signal, source),
  })
export const useSummaryChipCohorts = (
  filters: AttributionFilters,
  dimension: AttributionDimension,
  source: SummaryChipSource
) =>
  useQuery({
    ...defaults,
    staleTime: 60_000,

    queryKey: ['attribution-observability', 'summary-chips', 'cohorts', filters, dimension, source],
    queryFn: ({ signal }) => getSummaryChipCohorts(filters, dimension, signal, source),
  })
export const useSummaryChipTrend = (
  filters: AttributionFilters,
  axes: AttributionDimension[],
  enabled: boolean,
  source: SummaryChipSource
) =>
  useQuery({
    ...defaults,
    enabled,
    queryKey: ['attribution-observability', 'summary-chips', 'trend', filters, axes, source],
    queryFn: ({ signal }) => getSummaryChipTrend(filters, axes, signal, source),
  })
